<script lang="ts">
	import WebGeneralLayout from "./web/WebGeneralLayout.svelte";
	import PrintLayout from "./print/PrintLayout.svelte";
	import PwtsLib from "@ludans/murano-fantasy";

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const hashInUrl = urlParams.get("hash");
	const print = urlParams.has("print");

	let hash: string = hashInUrl || PwtsLib.randomHash();
	// hash = '0x7b7797650476b6a99e024ac7ac1c3011ff720ee57f789580a57c114f33255709';

	//let start = Date.now();
	const allPwtData = PwtsLib.genPwt(hash);
	const pwtData = allPwtData.pwtData;
	const stats = allPwtData.stats;
	//let end = Date.now();
	//let elapsed = end - start;
	//console.log('pwt generation', elapsed);

</script>

{#if !print}
	<WebGeneralLayout {hash} {pwtData} {stats} />
{:else}
	<PrintLayout {pwtData} {stats} />
{/if}
